<template>
    <div class="register-home-page-container">
        <h2 class="page-title">{{ $t('homePage.title') }}</h2>
        <div class="page-tips">
            <img class="tips-icon" src="https://cdn.lofty.com/image/fs/servicetool/20251225/7/original_142bc8b77a3f4c51.png" alt="" />
            <div class="tips-desc">
                {{ $t('homePage.tips') }}
            </div>
        </div>
        <div class="page-content-ads">
            <div class="address-label">{{ $t('homePage.addressLabel') }}</div>
            <div class="home-address-input">
                <input
                    ref="input"
                    type="text"
                    autocomplete="off"
                    name="address"
                    class="input"
                    :placeholder="$t('homePage.addressPlaceholder')"
                    v-model="address"
                    @focus="onFocus"
                    @compositionstart="onCompositionstart"
                    @compositionend="onCompositionend"
                    @input="onInput"
                    @blur="onBlur"
                />
                <div
                    class="close-box"
                    :class="{ show: !!address }"
                    @click="clearAddress"
                >
                    <span class="iconfont icon-search-close"></span>
                </div>
            </div>
            <div class="btn-actions">
                <div class="confirm-btn" @click="handleConfirm">{{ $t('homePage.confirmBtnText') }}</div>
                <div class="skip-btn">
                    <span class="skip-text" @click="handleSkip">{{ $t('homePage.skipBtnText') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import addressInput from '@/modules/md-profile/addressInput.js';
export default {
    mixins: [addressInput],
    i18next: {
        ns: 'common'
    },
    data: function() {
        return {
            address: '', // input v-model
        };
    },
    methods: {
        async handleConfirm() {
            this.$emit('handleNextStep', {
                homeAddress: this.address.trim()
            });
        },
        handleSkip() {
            this.$emit('handleNextStep');
        },
    }
};
</script>

<style lang="scss" scope>
@import '@/theme/mixin.scss';
.register-home-page-container {
    display: flex;
    flex-direction: column;
    h2 {
        flex-shrink: 0;
        font-size: 20px;
        font-weight: 700;
        color: var(--g-primary-color);
        margin-bottom: 30px;
        text-align: center;
        font-family: 'font-Montserrat-700';
    }
    .page-tips {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
        .tips-icon {
            width: 95px;
            height: 100px;
        }
        .tips-desc {
            text-align: center;
            font-size: 12px;
            color: var(--g-text-color);
            line-height: 1.5;
            b {
                font-weight: 700;
            }
        }
    }
    .page-content-ads {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        .address-label {
            font-size: 14px;
            color: var(--g-text-color);
        }
        .home-address-input {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: center;
            position: relative;
            input {
                border: 1px solid #dadada;
                padding-left: 10px;
                flex: 1;
                font-size: 14px;
                padding-right: 34px;
                box-sizing: border-box;
                box-shadow: none;
            }
            .close-box {
                display: none;
                position: absolute;
                right: 10px;
                line-height: 40px;
                color: #c6c8d1;
                z-index: 100;
                cursor: pointer;
                .iconfont {
                    font-size: 14px;
                }
                &.show {
                    display: block;
                }
            }
        }
    }
    .btn-actions {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .confirm-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 40px;
            border-color: var(--g-btn-background);
            background-color: var(--g-btn-background);
            color: var(--g-btn-color);
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;
            @include color-button-v2();
            @include color-button-hover();
            &.submit-disabled {
                cursor: not-allowed;
                opacity: 0.7;
            }
        }
        .skip-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: rgba(76, 132, 255, 1);
            font-size: 12px;
            text-decoration: underline;
            .skip-text {
                font-family: 'font-Montserrat-400';
                cursor: pointer;
            }
        }
    }
}
</style>
<style lang="scss">
.autocomplete {
    z-index: 1000;
}
</style>
